/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-header-submenu.get-names.ts 
*/
:host {
  box-sizing: border-box;
  display: block;
  min-height: var(--ace-semantic-navigation-submenu-height);
  width: 100%;
}
:host * {
  box-sizing: border-box;
}

.ace-header-submenu {
  align-items: center;
  background: var(--ace-color-primitive-surface-solid--100);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  -webkit-overflow-scrolling: touch; /* iOS */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.ace-header-submenu::-webkit-scrollbar {
  display: none;
  /* WebKit */
  height: 0;
  width: 0;
}
.ace-header-submenu__tabs {
  overflow-y: scroll;
  width: 100%;
  -webkit-overflow-scrolling: touch; /* iOS */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.ace-header-submenu__tabs::-webkit-scrollbar {
  display: none;
  /* WebKit */
  height: 0;
  width: 0;
}
.ace-header-submenu__tabs ace-tabs {
  --ace-tabs-height: var(--ace-semantic-navigation-submenu-height);
}
.ace-header-submenu__icon {
  align-items: center;
  background-color: var(--ace-header-submenu-icon-bg-color, var(--ace-color-brand-secondary--100));
  display: flex;
  flex-shrink: 0;
  height: var(--ace-semantic-navigation-submenu-height);
  justify-content: center;
  width: 2.75rem;
}
.ace-header-submenu__icon:focus-visible {
  outline: 0.125rem solid var(--ace-color-borders--focus);
  outline-offset: 0.125rem;
  z-index: 2;
}